module.exports = __webpack_public_path__ + "static/media/07-_DSC8452.6fbc575e.jpg";